import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import ShopLP from "../pages/lp/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <ShopLP />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;